/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRateStatResource
 */
export interface DailyRateStatResource {
    /**
     * 
     * @type {number}
     * @memberof DailyRateStatResource
     */
    minPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyRateStatResource
     */
    maxPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyRateStatResource
     */
    feeRate: number;
    /**
     * 
     * @type {string}
     * @memberof DailyRateStatResource
     */
    faqLink?: string;
}

/**
 * Check if a given object implements the DailyRateStatResource interface.
 */
export function instanceOfDailyRateStatResource(value: object): value is DailyRateStatResource {
    if (!('feeRate' in value) || value['feeRate'] === undefined) return false;
    return true;
}

export function DailyRateStatResourceFromJSON(json: any): DailyRateStatResource {
    return DailyRateStatResourceFromJSONTyped(json, false);
}

export function DailyRateStatResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRateStatResource {
    if (json == null) {
        return json;
    }
    return {
        
        'minPrice': json['minPrice'] == null ? undefined : json['minPrice'],
        'maxPrice': json['maxPrice'] == null ? undefined : json['maxPrice'],
        'feeRate': json['feeRate'],
        'faqLink': json['faqLink'] == null ? undefined : json['faqLink'],
    };
}

export function DailyRateStatResourceToJSON(value?: DailyRateStatResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'minPrice': value['minPrice'],
        'maxPrice': value['maxPrice'],
        'feeRate': value['feeRate'],
        'faqLink': value['faqLink'],
    };
}

